import { REFERRAL_TOKEN_HEADER } from './config';
import { markCustomerSourceHeaderExpired } from './customerSourceStorage';

// Referral token is single-use: mark it expired so it is dropped and not re-stored from the URL
export function clearUsedReferralTokenSource(): void {
  markCustomerSourceHeaderExpired(REFERRAL_TOKEN_HEADER);
}
